import { css } from '@emotion/react';
import styled from '@emotion/styled';

import Card from 'components/global/Card';

import { Breakpoints } from 'utils/const.styles';

export const HeadingCss = css`
	padding: 1rem;
	margin: 0 20%;
	@media ${Breakpoints.mobileLandscape} {
		margin: 0 var(--padding-2);
	}
`;

export const PgContainer = styled.div`
	background-color: var(--background-1);
	> div.dynamic-table {
		box-shadow: none;
		border: 1px solid var(--border-color);
		@media ${Breakpoints.mobileLandscape} {
			margin: var(--padding-3);
		}
	}
	> div.faqs {
		gap: var(--margin-3);

		@media ${Breakpoints.mobileLandscape} {
			margin: var(--padding-3) auto;
			width: 96%;
		}
	}
`;
export const TableContainer = styled(Card)`
	display: flex;
	flex: 1 0 auto;
	padding: 0;
	border: none !important;
`;

export const RowContainer = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: 2fr 1fr;
	grid-gap: var(--margin-5);
	margin-bottom: var(--margin-4);

	@media ${Breakpoints.tablet} {
		grid-template-columns: 1fr;
	}
`;
export const ColumnContainer = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	width: 100%;
	height: 100%;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	align-items: center;
	justify-content: flex-start;
	> form {
		padding: var(--padding-3) var(--padding-5);
	}
	&.form-items {
		align-items: flex-start;
		overflow: unset;
	}

	@media ${Breakpoints.mobile} {
		&.mobile {
			margin: var(--margin-3);
			width: 95%;
			background-color: var(--white);
			border: 1px solid var(--border-color);
			> div.card {
				border: none;
			}
		}
	}
`;

export const RowContainerInvite = styled.div`
	width: 100%;
	padding: var(--margin-2) 0;
	display: grid;
	grid-template-columns: 6fr 1fr 4fr;

	> input {
		width: 98%;
	}

	> button {
		width: 12rem;
		@media ${Breakpoints.mobileLandscape} {
			width: 8.5rem;
		}

		> span.button-text {
			overflow: unset;
		}
	}

	@media ${Breakpoints.mobileLandscape} {
		padding: 0 0 var(--padding-3) 0;
		grid-template-columns: 6fr 1fr;
	}
`;
export const RowContainerShare = styled.div`
	width: 100%;
	margin: var(--margin-2) 0;
	display: grid;
	grid-template-columns: 7.8fr 4fr;
	align-items: center;
	> span.copy-component {
		width: 100%;
		padding: 0;
		min-height: 5rem;
		overflow: auto;
		> div > button {
			width: 12rem;
			@media ${Breakpoints.mobileLandscape} {
				width: unset;
			}
		}
	}

	@media ${Breakpoints.mobileLandscape} {
		padding: 0 0 var(--padding-2) 0;
		grid-template-columns: 1fr;
	}
`;

export const RowSpaceContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin: var(--padding-1);
`;
export const RowEvenContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-evenly;
	margin: var(--padding-1);
	&.social-image {
		@media ${Breakpoints.mobileLandscape} {
			margin: var(--margin-3) 0 0 0;
		}
		> img {
			cursor: pointer;
		}
	}
	@media ${Breakpoints.mobileLandscape} {
		justify-content: flex-start;
		gap: var(--margin-3);
	}
`;
export const RowCenterContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	margin: var(--padding-1) 0;
`;
export const RowCenterTopContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	justify-content: center;
	margin: var(--padding-1) 0;
	position: relative;
	width: 100%;
	> div > div > div.swiper-slide {
		background-color: var(--white);
		border: 1px solid var(--border-color);
		margin: 3rem var(--margin-1);
	}

	.swiper-pagination-bullet {
		background-color: var(--black-20);

		&.swiper-pagination-bullet-active {
			background-color: var(--black);
		}
	}
`;

export const DottedLineContainer = styled.div`
	position: absolute;
	top: 59%;
	left: 24%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	width: 30%;
	height: 0;
	body[dir='rtl'] & {
		left: unset;
		right: 24%;
	}
`;
export const DottedLineContainer2 = styled.div`
	position: absolute;
	top: 59%;
	right: 12%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	width: 30%;
	height: 0;
	body[dir='rtl'] & {
		right: unset;
		left: 12%;
	}
`;
export const DottedLine = styled.div`
	position: absolute;
	border-top: 2px dashed #ccc;
	width: 55%;
	height: 0;
	::after {
		content: ' ';
		display: block;
		position: absolute;
		top: -7px;
		right: 0;
		width: 10px;
		height: 10px;
		border-radius: 50%;
		background: #ccc;
	}
`;
